<template>
    <div class="content">
        <div class="person-content">
            <el-form :model="ruleForm" :rules="isReadOnly? null: rules" ref="ruleForm" label-position="left" label-width="100px" class="register-ruleForm">
                <el-form-item prop="name" label="姓名" class="input-each-div"  :show-message= false>
                    <el-input class="input-each" v-model="ruleForm.name" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入姓名'" :readonly="isReadOnly"></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="手机号" class="input-each-div"  @click="toUpdatePhone"  :show-message= false>
                    <el-input class="input-each" v-model="ruleForm.phone" autocomplete="off" maxlength="11" :placeholder="isReadOnly ? '' : '请输入手机号'" 
                    :readonly="isReadOnly"></el-input>
                    <div v-if="loginType === '0' && !isReadOnly" class="sendBtn"><i class="el-icon-arrow-right"></i></div>  
                </el-form-item>
                <el-form-item prop="idcard" label="身份证号" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.idcard" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入身份证号'" :readonly="isReadOnly"></el-input>
                </el-form-item>
                <el-form-item prop="company" label="工作单位" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.company" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入工作单位'" :readonly="isReadOnly"></el-input>
                </el-form-item>
                <el-form-item prop="position" label="职务" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.position" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入职务'" :readonly="isReadOnly"></el-input>
                </el-form-item>
                <el-form-item prop="email" label="邮箱" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.email" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入邮箱'" :readonly="isReadOnly"></el-input>
                </el-form-item>
                <el-form-item prop="sno" label="学号" class="input-each-div">
                    <el-input class="input-each" v-model="ruleForm.sno" autocomplete="off"
                        :placeholder="isReadOnly ? '' : '请输入学号'" :readonly="isReadOnly"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="my-content-bank" @click="toBindBank()">
            <div class="title-each">银行卡</div>
            <div class="right-btn">
                <span v-if = "bankStatus === '1'" class="bindSucess">已绑定</span>
                <span v-else class="bindFail">未绑定</span>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="all-btn" v-if="!isReadOnly">
            <div class="over-btn" @click="submitForm('ruleForm')">保存</div>
        </div>
    </div>
</template>
<script>
import { getLoginInfo,updateStudent } from '@/api/common'   //路径
import { showToast } from 'vant';
export default {
    name: 'PersonPage',
    props: ['id'],
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '' || value.length < 11 || value.substring(0, 1) !== '1') {
                showToast(value === '' ? '请输入手机号' :'手机号格式不正确' );
                callback(value === '' ? new Error('请输入手机号') : new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        var validateName = (rule, value, callback) => {
            if (value === '') {
                showToast('请输入姓名');
                callback('请输入姓名');
            } else {
                callback();
            }
        };
        return {
            merchantId: '',
            ruleForm: {
                name: '',
                phone: '',
                idcard: '',
                company: '',
                position: '',
                email: '',
                sno: '',
                captcha: '',
                code: ''
            },
            rules: {
                name: [
                    { required: true, validator: validateName, trigger: 'blur' }
                ],
                phone: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ],
            },
            isReadOnly: true, // true: 禁止保存 false：可保存
            loginType: '1',
            bankStatus: '0' // 0: 未绑定 1：已绑定
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.getPersonInfo();
    },
    methods: {
        getPersonInfo() {
            let params = {};
            getLoginInfo(params).then((res) => {
                this.ruleForm = res.student;
                this.isReadOnly = res.student.enableReg === "1" ? false: true;
                this.loginType = res.student.loginType || '1';
                this.bankStatus = res.student.bankStatus || '0';
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.edit();
                } else {
                    return false;
                }
            });
        },
        edit() {
            let that = this;
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            params.merchantId = this.merchantId;
            delete params.enableReg;
            delete params.loginType;
            updateStudent(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    that.$message({
                        duration: 1000,
                        message: '保存成功',//提示的信息
                        type: 'success',//类型是成功
                    });
                }
            })
        },
        toUpdatePhone() {
            if(this.loginType === '1' || this.isReadOnly === true) return;
            this.$router.push({ name: 'resetPhone', params: { id: this.merchantId } });
        },
        toBindBank() {
            this.$router.push({
                path: '/bindBank/' + this.merchantId, query: {
                    bankStatus: this.bankStatus,
                }
            });
        }
    }
}
</script>

<style scoped>
.content {
    min-height: 100vh;
    background-color: #fafafa;
}

.person-content {
    overflow: hidden;
}

.input-each-div {
    position: relative;
    padding: 5px 15px;
    margin-bottom: 1px;
    background-color: #fff;
}

.input-each-div :deep(.el-input__inner) {
    padding: 0;
    border: 0;
}

.all-btn {
    margin-top: 75px;
    padding: 0 40px;
    overflow: hidden;
}

.over-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #0095D9;
    border-radius: 32px;
}

.sendBtn {
    position: absolute;
    right: 0;
    top: 0;
    width: 18px;
    height: 18px;
    color: #666666;
}

.my-content-bank {
  padding: 15px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.title-each {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  font-weight: 500;
}

.right-btn {
  display: flex;
  align-items: center;
  height: 20px;
  font-size: 20px;
}

.bindSucess {
    margin-right: 12px;
    font-size: 14px;
    color: #13D275;
}

.bindFail {
    margin-right: 12px;
    font-size: 14px;
    color: #F11515;
}


</style>